import {fromJS, Map } from 'immutable';
import config from 'config';
import actions from 'redux/constants/admin/personal';
import history from '../../../../history';
import {checkJsonResponse, checkJsonResponseWithMessage, logErrorConsole} from 'utils/actions';

const checkFilter = filter => {
  if(filter) return `&${filter}=true`
  return ''
}

export const personalIsSubmitting = (data) => ({
  type: actions.PERSONAL_IS_SUBMITTING,
  data
});

export const personalIsLoading = (data) => ({
  type: actions.PERSONAL_IS_LOADING,
  data
});

export const personalCreateFailed = (data) => ({
  type: actions.PERSONAL_CREATE_FAILED,
  data
})

export const changePersonalValue = (data, key) => ({
	type: actions.SET_PERSONAL_ITEM_VALUE,
	key,
	data
});

export const personalChangeItem = (data) => ({
	type: actions.SET_PERSONAL_ITEM,
	data
});

export const personalCleanStore = () => (dispatch) => {
  dispatch(personalChangeItem(new Map({
    phone: "",
    personal_type: "",
    position_title: "",
    institution: null,
    doctor: null,
    is_responsible: false,
    cabinet_number: "",
    schedule: "",
    comment: "",
    is_admin: false,
    is_manager_document: false,
    is_operator: false,
    is_manager_institution: false,
    is_registry: false, 
  })));
}

export const searchAllPersonal = ({ name, institution="", profession='', type='', limit=25, offset=0, role='' } = {}) => (dispatch) => {
  dispatch(personalIsLoading(true));
  let query = role === 'is_operator' ? `&is_operator=true&is_responsible=true` : checkFilter(role)
  if (institution === null){
    fetch(`${config.apiHost}/staff/?search=${name}&institution__isnull=True&doctor__profession_classification=${profession}&personal_type=${type}${query}&limit=${limit}&offset=${offset}`)
    .then(checkJsonResponse)
    .then((json) => {
      const data = fromJS(json);
      dispatch({
        type: actions.SET_ADMIN_PERSONAL,
        data
      });
      dispatch(personalIsLoading(false));
    })
    .catch(e => console.log(e))
  } else {
    fetch(`${config.apiHost}/staff/?search=${name}&institution=${institution}&doctor__profession_classification=${profession}&personal_type=${type}${query}&limit=${limit}&offset=${offset}`)
    .then(checkJsonResponse)
    .then((json) => {
      const data = fromJS(json);
      dispatch({
        type: actions.SET_ADMIN_PERSONAL,
        data
      });
      dispatch(personalIsLoading(false));
    })
    .catch(e => console.log(e))
  }
    
};

export const submitNewPersonal = (url, personalData, id = null) => (dispatch, getState) => {
  dispatch(personalIsSubmitting(true));
  dispatch(personalCreateFailed(false));

  let method = id ? 'put' : 'post';
  let path = id ? `${config.apiHost}/staff/${id}/` : `${config.apiHost}/staff/`;

  const options = {
    method,
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
      "Content-type": 'application/json'
    },
    body: JSON.stringify({ ...personalData })
  }

  fetch(path, options)
  .then(checkJsonResponseWithMessage)
  .then((json) => {
    history.push(`${url}${json.id}`);
  })
  .catch(e => {
    dispatch(personalCreateFailed(e));
  })
  .then(() => {
    dispatch(personalIsSubmitting(false))
  })
};

export const loadPersonalDetail = (id) => (dispatch, getState) => {
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    }
  }
  fetch(`${config.apiHost}/staff/${id}/`, options)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.SET_PERSONAL_ITEM,
      data
    })
  })
  .then(logErrorConsole)
};

export const deletePersonal = (id) => (dispatch, getState) => {
  const options = {
    method: "delete",
    headers: {
       "Authorization": "Token " + getState().auth.get('token'),
    }
  };
  fetch(`${config.apiHost}/staff/${id}/`, options)
  .then(response => {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return null;
  })
  .then(() => {
    history.push(`/admin/personal`);
  })
  .catch(e => {
    console.log(e);
  })
};



// WEBPACK FOOTER //
// ./src/redux/actions/admin/personal/index.js